<template>
  <div>
    <add-cashout-method
      :country_id="country_id"
      :is-active.sync="isAdding"
      @added="cashoutMethodAdded"
    />
    <data-table
      title="Cashout Methods"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Cashout Method
        </v-btn>
      </template>
      <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.status === 'done'">
          mdi-progress-check
        </v-icon>
        <v-icon color="grey" v-else-if="item.status === 'pending'">
          mdi-progress-alert
        </v-icon>
        <v-icon color="primary" v-else-if="item.status === 'started'">
          mdi-progress-clock
        </v-icon>
        <v-icon color="error" v-else-if="item.status === 'error'">
          mdi-progress-close
        </v-icon>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <v-icon medium title="Delete Country" @click.stop="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCashoutMethod from "./new";

export default {
  props: { country_id: { required: true, type: [Number, String] } },
  components: { AddCashoutMethod },
  data() {
    return {
      isAdding: false,
      showArchived: false,
      headers: {
        "cashout_method.name": "Name",
        "cashout_method.payment_type.name": "Type",
        "cashout_method.payment_provider.name": "Provider",
        "cashout_method.min_amount": "Min Amount",
        "cashout_method.max_amount": "Max Amount",
        actions: "Actions",
      },
      fields: {
        min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  computed: {
    url() {
      return `api/v1/transactions/transferCountries/${this.country_id}/cashoutMethods`;
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    cashoutMethodAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails(cashOutMethod) {
      const { cashout_method } = cashOutMethod;
      this.$router.push({
        name: "platform.cashoutMethods.show",
        params: { id: cashout_method.id },
      });
    },
    deleteItem(item) {
      Notify.confirm(`The cashout method will be removed.`).then(() => {
        this.$http
          .delete(
            `/api/v1/transactions/transferCountries/${this.country_id}/cashoutMethods/${item.id}`,
          )
          .then(() => {
            Notify.success("Cashout method was successfully deleted.");
            // refresh the table data
            this.$refs.table.fetchData();
          });
      });
    },
  },
};
</script>
